import { autoinject, customElement } from 'aurelia-framework';

@autoinject
@customElement('as-table-skeleton')
export class TableSkeleton {
  columnClassNames: string[] = [];

  constructor(private element: Element) { }

  attached() {
    const columns = this.element.parentNode.querySelector('thead').querySelectorAll('th');
    columns.forEach(c => this.columnClassNames.push(c.className));
  }

  getRandomWidth() {
    return Math.floor(Math.random() * 75) + 25;
  }
}
